import * as React from "react";
import { GlideFC } from "lib/glide-fc";
import TextField from "webapp/ui/smart/text-field/text-field";
import "twin.macro";
import { GlideIcon } from "sharedUI/ui/views/glide-icon/glide-icon";
import Img from "webapp/ui/smart/img/img";
import { WireButton } from "../wire-button/wire-button";
import { Appearance } from "common/generator/components/button-appearance";

interface Props {
    title?: string;
    subtitle?: string;
    image?: string;
    contactAddress?: string;
    contactEmail?: string;
    contactPhone?: string;

    name?: string;
    onNameChange?: (newVal: string) => void;
    email?: string;
    onEmailChange?: (newVal: string) => void;
    phone?: string;
    onPhoneChange?: (newVal: string) => void;
    message?: string;
    onMessageChange?: (newVal: string) => void;
    onSubmit?: () => void;
}

export const FormSection: GlideFC<Props> = p => {
    const {
        contactAddress,
        contactEmail,
        contactPhone,
        email,
        message,
        name,
        onEmailChange,
        onMessageChange,
        onNameChange,
        onPhoneChange,
        phone,
        subtitle,
        title,
        image,
        onSubmit,
    } = p;

    const style: React.CSSProperties = {
        backgroundImage: `linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ), url("${image}")`,
    };

    return (
        <div tw="w-full relative rounded-lg shadow-md">
            <div
                tw="flex flex-col rounded-lg overflow-hidden border border-solid border-border-base
                    gp-lg:flex-row">
                <div
                    style={style}
                    tw="isolate w-full text-sm border-0 border-r border-solid border-border-base flex-shrink-0 relative
                        gp-lg:(w-96 text-base)">
                    <Img
                        tw="z-index[-1] object-cover absolute inset-0 w-full h-full overflow-hidden filter brightness-50"
                        src={image}
                    />
                    <div
                        tw="z-10 p-4 isolate flex flex-col justify-center all-child:(mb-4 whitespace-pre-wrap
                            color[white])">
                        {title && <div tw="font-medium text-xl text-center">{title}</div>}
                        {subtitle && <div tw="text-center">{subtitle}</div>}
                        {contactAddress && (
                            <div tw="flex items-center color[#ffffffdd]">
                                <GlideIcon tw="opacity-75 mr-2" kind="monotone" icon="mt-g-logo" iconSize={20} />
                                {contactAddress}
                            </div>
                        )}
                        {contactEmail && (
                            <div tw="flex items-center color[#ffffffdd]">
                                <GlideIcon tw="opacity-75 mr-2" kind="monotone" icon="mt-g-logo" iconSize={20} />
                                {contactEmail}
                            </div>
                        )}
                        {contactPhone && (
                            <div tw="flex items-center color[#ffffffdd]">
                                <GlideIcon tw="opacity-75 mr-2" kind="monotone" icon="mt-g-logo" iconSize={20} />
                                {contactPhone}
                            </div>
                        )}
                    </div>
                </div>
                <div tw="flex-1 flex flex-col items-center all-child:(p-4 flex flex-col) bg-n0">
                    <div tw="flex flex-col justify-center max-w-xl w-full">
                        {onNameChange && (
                            <div>
                                <div tw="pl-4">Name:</div>
                                <TextField value={name ?? ""} onChange={onNameChange} />
                            </div>
                        )}
                        {onEmailChange && (
                            <div>
                                <div tw="pl-4">Email:</div>
                                <TextField value={email ?? ""} onChange={onEmailChange} />
                            </div>
                        )}
                        {onPhoneChange && (
                            <div>
                                <div tw="pl-4">Phone:</div>
                                <TextField value={phone ?? ""} onChange={onPhoneChange} />
                            </div>
                        )}
                        {onMessageChange && (
                            <div>
                                <div tw="pl-4">Message:</div>
                                <TextField value={message ?? ""} onChange={onMessageChange} />
                            </div>
                        )}
                        <div tw="self-end">
                            <WireButton
                                tw="w-auto
                                    gp-sm:w-40"
                                appearance={Appearance.Filled}
                                onClick={onSubmit}>
                                Submit
                            </WireButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
